import * as React from 'react';

type Props = {
    className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="16"
            viewBox="0 0 12 16"
            className={className}
        >
            <path d="M7.667 0H4.333C3.598 0 3 .598 3 1.333H1.333C.598 1.333 0 1.931 0 2.667v12C0 15.402.598 16 1.333 16h9.334c.735 0 1.333-.598 1.333-1.333v-12c0-.736-.598-1.334-1.333-1.334H9C9 .598 8.402 0 7.667 0zM4.333 1.333h3.334v1.334H4.333v-.662V2v-.667zm6.334 1.334v12H1.333v-12H3C3 3.402 3.598 4 4.333 4h3.334C8.402 4 9 3.402 9 2.667h1.667z"></path>
        </svg>
    );
}
